import { isMobile } from '@adornis/base/client/frontend-helpers/window-size';

export function generateOptions(
  xLabel: string,
  yLabel: string,
  options?: { legend?: boolean; ymin?: number; ymax?: number },
): _DeepPartialObject<any> | undefined {
  return {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: isMobile() ? 1.2 : 2,
    locale: 'en-EN',
    scales: {
      x: {
        // // type: 'linear',
        // display: true,
        // ticks: {
        //   // stepSize: 10,
        //   // max: RANGE, // enforces strict max, suggestedMax gives way if there is a greater value in the data
        //   beginAtZero: true,
        // },
        // grid: {
        //   lineWidth: 1,
        //   zeroLineWidth: 1, // Migration guide says to use scriptable axes instead
        // },
        title: { display: true, align: 'end', text: xLabel },
        // max: 50,
        // min: 0,
      },
      y: {
        type: 'linear',
        display: true,
        // suggestedMin: -1,
        // suggestedMax: 1,
        min: options?.ymin,
        max: options?.ymax,
        ticks: {
          // stepSize: 0.2,
          beginAtZero: true,
        },
        grid: {
          lineWidth: 1,
          zeroLineWidth: 1,
        },
        title: { display: true, align: 'end', text: yLabel },
      },
    },
    animation: true,
    plugins: {
      legend: {
        display: options?.legend || false,
        title: { text: 'Leistungsniveaus', display: true },
        fontSize: 23,
      },
      decimation: { enabled: true, samples: 10, threshold: 5 },
      tooltip: {
        displayColors: false,
        callbacks: {
          title: function (ctx) {
            return ctx[0].dataset.label;
          },
          label: function (ctx) {
            return ctx.formattedValue + ' Schüler*innen';
          },
        },
      },
      zoom: {
        pan: { enabled: false, mode: 'y' },
        limits: { enable: true },
        zoom: {
          wheel: {
            enabled: false,
          },
          pinch: {
            enabled: false,
          },
          // mode: 'y',
        },
      },
    },
  };
}
